export const ROUTES = {
  HEALTH: {
    LIVENESS: "/r/healthz",
    READINESS: "/r/readyz",
  },
  OBSERVABILITY: {
    // Prometheus metrics, scraped pod-locally by the Dash0 operator.
    // NOT prefixed with /r: this is hit directly on localhost:3000 inside the
    // pod, never through the shared Ingress, so no Ingress disambiguation is
    // needed. The path is the operator's default scrape path.
    METRICS: "/metrics",
  },
  PUBLIC: {
    HOME: "/",
    SIGN_IN: "/r/signin",
    SIGN_OUT: "/r/signout",
    I18N_SET_LOCALE: "/r/i18n/locale",
    ROADRUNNER: "/roadrunner",
    CANCEL_WITHDRAW: "/cancellationandwithdrawal",
    CANCEL_WITHDRAW_CONFIRMATION: "/cancellationandwithdrawal/confirmation",
    TEST_ONE: "/r/test/one",
    TEST_TWO: "/r/test/two",
  },
  AUTHENTICATED: {
    CHATS: "/chats",
    DISCOVER_NEARBY: "/discover/nearby",
    MATCH_GAME: "/match-game",
    MY_PROFILE: "/my-profile",
    USER_BANNED: "/r/banned",
    TEST_PROTECTED: "/r/test/protected",
  },
  API: {
    I18N_LOCALE: "/r/api/i18n/locale",
    CLIENT_LOG: "/r/api/client-log",
    CREDITS_TOKEN: "/r/api/credits-token",
  },
};
